import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledActionsButtonLink } from '../StyledComponents';
import { StyledPipe } from './StyledPipe';

export const ViewDeveloperLicense = ({
  setIsModalOpened,
}: {
  setIsModalOpened: (isOpened: boolean) => void;
}) => (
  <>
    <StyledActionsButtonLink
      appearance="link"
      onClick={() => {
        setIsModalOpened(true);
      }}
      data-cy="actions-section-view-developer-license-button"
    >
      <FormattedMessage
        id="mac.licenses.view.developer.license"
        defaultMessage="View Developer License"
      />
    </StyledActionsButtonLink>
    <StyledPipe />
  </>
);
